import { render, staticRenderFns } from "./drawbackDetail.vue?vue&type=template&id=45833680&scoped=true"
import script from "./drawbackDetail.vue?vue&type=script&lang=js"
export * from "./drawbackDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45833680",
  null
  
)

export default component.exports